import { ExclamationCircleFilled } from '@ant-design/icons';
import { Text } from '@clockout-dev/design-elements';
import styles from './styles/formError.module.scss';

/**
 * Inline form validation error with alert semantics.
 *
 * @param {Object} props
 * @param {string} props.error
 * @param {string} [props.id] Optional id for aria-describedby on the related field.
 * @returns {React.ReactNode|null}
 */
function FormError({ error, id }) {
    const hasError = Boolean(error) && error !== '';
    if (!hasError) return null;

    return (
        <div
            id={id}
            className={styles.inviteError}
            role="alert"
            aria-live="assertive">
            <ExclamationCircleFilled
                className={styles.inviteErrorIcon}
                aria-hidden="true"
            />
            <Text as="span" size="s" className={styles.inviteErrorText}>
                {error}
            </Text>
        </div>
    );
}

export default FormError;
